import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';

export type PopupMenuProps = {
    anchorEl: HTMLElement | null;
    onClose: () => void;
    options: PopupOption[];
    anchorOrigin?: {
        vertical: 'top' | 'bottom';
        horizontal: 'left' | 'right';
    };
    transformOrigin?: {
        vertical: 'top' | 'bottom';
        horizontal: 'left' | 'right';
    };
    offsetX?: number | string;
    offsetY?: number | string;
    open?: boolean;
}

type PopupOption = {
    icon: React.ReactNode;
    label: string;
    onClick: (e: React.MouseEvent<HTMLLIElement, MouseEvent>) => void;
    labelColor?: string;
}

const PopupMenu: React.FC<PopupMenuProps> = ({
    anchorEl,
    onClose,
    options,
    anchorOrigin,
    transformOrigin,
    offsetX = 0,
    offsetY = 0,
    open = true,
}) => (
    <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl) && open}
        onClose={onClose}
        onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
        }}
        onContextMenu={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onClose();
        }}
        anchorOrigin={anchorOrigin ?? {
            vertical: 'top',
            horizontal: 'right',
        }}
        transformOrigin={transformOrigin ?? {
            vertical: 'top',
            horizontal: 'left',
        }}
        slotProps={{
            paper: {
                sx: {
                    mt: offsetY,
                    ml: offsetX,
                }
            }
        }}
    >
        {
            options.map((option, index) => (
                <MenuItem key={index} onClick={(e) => option.onClick(e)}>
                    <ListItemIcon >{option.icon}</ListItemIcon>
                    <ListItemText primary={option.label} />
                </MenuItem>
            ))
        }
    </Menu >
);

export default PopupMenu; 